module.exports = __webpack_public_path__ + "img/facebook.4fd38499.7984a9b6.png";